import { useEffect } from 'react';
import { camelizeKeys } from 'humps';
import { socketSubscribe, socketUnsubscribe } from '@namespace/socket';
import {
  notificationCenterActions,
  useNotificationCenterStore
} from '../../store';
import { useIsCritAllowedOnCurrentPage } from '../useIsCritAllowedOnCurrentPage';

const { ADD_NOTIFICATIONS, ADD_CRITICAL_NOTIFICATION, SET_HAS_NOTIFICATIONS } =
  notificationCenterActions;

export const useSubscribeSocketNotifications = () => {
  const isNotificationsLoaded = useNotificationCenterStore(
    'isNotificationsLoaded'
  );
  const isCritsAllowed = useIsCritAllowedOnCurrentPage();

  useEffect(() => {
    socketSubscribe({
      name: 'NotificationCenterNotifications',
      types: ['notificationCenterNewNotification'],
      callback: (data) => {
        const parsedData = camelizeKeys(data);
        const {
          data: { hasNotifications, notification }
        } = parsedData;

        if (notification != null) {
          const isCritical = notification?.importance === 'critical';

          if (isCritical) {
            ADD_CRITICAL_NOTIFICATION({
              notification,
              isAddToQueue: isCritsAllowed
            });
          }
          ADD_NOTIFICATIONS({ notifications: [notification] });
        }
        SET_HAS_NOTIFICATIONS(hasNotifications);
      }
    });

    return () => {
      socketUnsubscribe('NotificationCenterNotifications');
    };
  }, [
    isNotificationsLoaded,
    ADD_CRITICAL_NOTIFICATION,
    ADD_NOTIFICATIONS,
    SET_HAS_NOTIFICATIONS,
    isCritsAllowed
  ]);
};
